import React, { useEffect, useState } from 'react';
import { api } from '../lib/api';

const Settings: React.FC = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const storedTheme = localStorage.getItem('theme');
    setDarkMode(storedTheme === 'dark');
  }, []);

  useEffect(() => {
    localStorage.setItem('theme', darkMode ? 'dark' : 'light');
    document.documentElement.dataset.theme = darkMode ? 'dark' : 'light';
  }, [darkMode]);

  async function deleteAll() {
    if (!confirm('Delete all profile, broker, exposure, and request data? This cannot be undone.')) return;
    setMessage('');
    try {
      await api('/api/settings/delete-all-data', { method: 'POST' });
      setMessage('Data deleted. Log in again if your session was cleared.');
    } catch (err: any) {
      setMessage(err?.message || 'Delete failed');
    }
  }

  return (
    <div className="pageStack narrowStack">
      <section className="pageIntro">
        <div><span className="eyebrow">Settings</span><h1>Keep the tool simple.</h1><p>Only the essentials are here: theme, deployment status, and reset.</p></div>
      </section>

      <section className="panelCard settingsPanel">
        <div className="settingsRow"><div><strong>Dark mode</strong><p>Switch the app theme on this browser.</p></div><input type="checkbox" checked={darkMode} onChange={(e) => setDarkMode(e.target.checked)} /></div>
        <div className="settingsRow"><div><strong>Email sending</strong><p>Uses Cloudflare Pages secrets: EMAIL_PROVIDER, FROM_EMAIL, REPLY_TO_EMAIL, and RESEND_API_KEY.</p></div><span className="badge blue">Configured in Cloudflare</span></div>
        <div className="settingsRow"><div><strong>Storage</strong><p>D1 is used for profile, findings, and requests. R2 is reserved for evidence.</p></div><span className="badge good">Cloudflare</span></div>
      </section>

      <section className="panelCard dangerZone">
        <div><span className="eyebrow">Danger zone</span><h2>Delete app data</h2><p>Clears profile, broker, exposure, request, and session data from D1.</p></div>
        <button className="dangerButton" onClick={deleteAll}>Delete all data</button>
      </section>
      {message && <div className="notice warn">{message}</div>}
    </div>
  );
};

export default Settings;
